const individual = `
query individual($where: individualWhereInput $skip: Int, $limit: Int, $sort: sortInput,){
  individuals(where:$where skip: $skip, limit: $limit, sort: $sort,){
    totalCount
    list {
      __typename
      id
      name
      englishFirstName
      englishLastName
      chineseFirstName
      chineseLastName
      email
      dateOfBirth
      gender
      occupation
      maritalStatus
      employmentStatus
      salutation
      preferredCommunicationChannel
      preferredLanguage
      countryOfResidency
      acceptsMarketing
      attachments{ path fileName createdAt lastModifiedAt }
      contacts{ id type value }
      identities{ id type value }
      addresses{ id fields type }
      events{
        timestamp
        by{
          username
        }
        type
      }
      facts {
        id
        type
        value {
          stringValue
          numberValue
          booleanValue
          dateValue
          arrayValue {
            stringValue
          }
          objectValue {
            key
            value{
              stringValue
              numberValue
              booleanValue
              dateValue
            }
          }
        }
      }
      notes{ id title content createdAt createdBy { username } }
      relationships { 
        type 
        entity {
          id
          name
        } 
      }
      createdAt
      createdBy { username }
      lastModifiedAt
      lastModifiedBy { username }
    }  
  } 
}
`
const individualCredentials = `
query individualCredentials($where: individualWhereInput $skip: Int, $limit: Int, $sort: sortInput,){
  individuals(where:$where skip: $skip, limit: $limit, sort: $sort,){
    list {
      __typename
      id
      name
      englishFirstName
      englishLastName
      chineseFirstName
      chineseLastName
      email
      dateOfBirth
      gender
      occupation
      maritalStatus
      employmentStatus
      salutation
      preferredCommunicationChannel
      preferredLanguage
      countryOfResidency
    }  
  } 
}
`

const individualObjects = `
query individualObjects($where: individualWhereInput){
  individuals(where:$where){
    list {
      id
      name
      notes{ id title content }
      relationships { 
        type 
        entity {
          id
          name
          __typename
          contacts { type value id}
          addresses{ id fields type }
          facts {
            id
            type
            value {
              stringValue
              numberValue
              booleanValue
              dateValue
              arrayValue {
                stringValue
              }
            }
          }
        } 
      }
    }  
  } 
}
`

const company = `
query company($where: companyWhereInput $skip: Int, $limit: Int, $sort: sortInput,){
  companies(where:$where skip: $skip, limit: $limit, sort: $sort,){
    totalCount
    list {
      __typename
      id
      events{
        timestamp
        by{
          username
        }
        type
      }
      name
      registrationNumber
      natureOfBusiness
      acceptsMarketing
      attachments{ path fileName }
      source
      contacts{ id type value }
      addresses{ id fields type }
      facts {
        id
        type
        value {
          stringValue
          numberValue
          booleanValue
          dateValue
          arrayValue {
            stringValue
          }
          objectValue {
            key
            value{
              stringValue
              numberValue
              booleanValue
              dateValue
            }
          }
        }
      }
      notes{ id title content createdAt createdBy { username }}
      relationships { 
        type 
        entity {
          id
          name
        } 
      }
      createdAt
      createdBy { username }
    }  
  } 
}
`
const companyCredentials = `
query companyCredentials($where: companyWhereInput $skip: Int, $limit: Int, $sort: sortInput,){
  companies(where:$where skip: $skip, limit: $limit, sort: $sort,){
    list {
      __typename
      id
      name
      registrationNumber
      natureOfBusiness
      acceptsMarketing
    }  
  } 
}
`

const companyObjects = `
query companyObjects($where: companyWhereInput){
  companies(where:$where){
    list {
      id
      name
      notes{ id title content }
      relationships { 
        type 
        entity {
          id
          name
          __typename
          addresses{ id fields type }
          contacts { type value id}
          facts {
            id
            type
            value {
              stringValue
              numberValue
              booleanValue
              dateValue
              arrayValue {
                stringValue
              }
            }
          }
        } 
      }
    }  
  } 
}
`

const policiesOfIndividual = `
query policiesOfIndividual($where: individualWhereInput $skip: Int, $limit: Int, $sort: sortInput,){
  individuals(where:$where skip: $skip, limit: $limit, sort: $sort){
    list {
      __typename
      holderOf{
        id
        createdAt
        holder{ name }
        issuerNumber
        status
        acceptedOffer{
          premium{ 
            formattedPrice
            appliedDiscounts{ code } 
          }
          product{ name insurer{ name } productId{type plan version} }
        }
        offers {
          premium {
            appliedDiscounts{ code }
          }
        }
      }
    }
  } 
}
`

const policiesOfCompany = `
query policiesOfCompany($where: companyWhereInput $skip: Int, $limit: Int, $sort: sortInput,){
  companies(where:$where skip: $skip, limit: $limit, sort: $sort,){
    list {
      __typename
      holderOf{
        createdAt
        id
        holder{ name }
        issuerNumber
        status
        acceptedOffer{
          premium{ 
            formattedPrice
            appliedDiscounts{ code } 
          }
          product{ name insurer{ name } productId{type plan version} }
        }
      }
    }
  } 
}
`

const deleteCustomer = `
mutation deleteCustomer($id: String!){
  deleteEntity(id: $id){
    status
    errors
  }
}
`

const createIndividual = `
mutation createIndividual($createIndividualInput: createIndividualInput!){
  createIndividual(createIndividualInput: $createIndividualInput){
    status
    createdStatus { id }
  }
}
`

const createCompany = `
mutation createCompany($createCompanyInput: createCompanyInput!){
  createCompany(createCompanyInput: $createCompanyInput){
    status
    createdStatus { id }
  }
}
`
const createObject = `
mutation createObject($createObjectInput: createObjectInput!){
  createObject(createObjectInput: $createObjectInput){
    createdStatus { id }
    status
  }
}
`

const addLink = `
mutation addLink($linkInput: createLinkInput!){
  addLink(linkInput: $linkInput){
    status
  }
}
`

const inviteIndividual = `
mutation inviteIndividual($clientId: String! $inviteIndividualInput: inviteIndividualInput!){
  inviteIndividual(clientId: $clientId inviteIndividualInput: $inviteIndividualInput){
    id
  }
}
`

const assignRole = `
mutation assignRoleToLogin($loginId: String! $permissionGroupId: String!) {
  addToPermissionGroup(
    loginId: $loginId
    permissionGroupId: $permissionGroupId
  ) {
    errors
    status
  }
}
`

const query = {
	individual,
	individualCredentials,
	individualObjects,
	company,
	companyCredentials,
	companyObjects,
	policiesOfIndividual,
	policiesOfCompany
}

const mutation = {
	deleteCustomer,
	createIndividual,
	createCompany,
	createObject,
	addLink,
	inviteIndividual,
	assignRole
}

export { query, mutation }
